import e, { useEffect as tt } from "react";
import p from "classnames";
import M from "lodash";
import { u as U } from "./ThemeProvider--i7ESlT5.es.js";
import { u as T } from "./utils-C0l876fA.es.js";
import { S as et } from "./Spinner-CRP4P3TK.es.js";
import { D as ot } from "./DotBounceLoading-BQiSmZUw.es.js";
import { I as S } from "./Icon-BuIPTPJn.es.js";
import { T as at } from "./Tooltip-B-bmRvX4.es.js";
import { T as nt } from "./index-Dd-4N6BE.es.js";
import { D as lt } from "./DarkModeProvider-xoZXm3ct.es.js";
import './Button.css';const rt = "#ccc", st = "#000", ct = "#fff", it = "#fff", dt = "#fff", ut = "#ccc", mt = "#000", _t = "#fff", ft = "#ccc", kt = "#ccc", bt = "#ac2f96", Ct = "#fff", yt = "#ccc", pt = "#4d4e8c", Tt = "#fff", Bt = "#fff", ht = "Button-default-module__outline___0Fj-O", At = "Button-default-module__linkButton___yCrWm", Et = "Button-default-module__stateful___4NGdE", Nt = "Button-default-module__error___n-oIw", Dt = "Button-default-module__secondary___iUywm", vt = "Button-default-module__icon___PwCJP", N = {
  copyLinkTaskDisabledColor: rt,
  copyLinkTaskPrimaryColor: st,
  copyLinkTaskAltColor: ct,
  actionActiveColor: it,
  primaryMutedActionActiveColor: dt,
  addTaskDisabledColor: ut,
  addTaskPrimaryColor: mt,
  addTaskAltColor: _t,
  addTaskActiveColor: ft,
  readTaskDisabledColor: kt,
  readTaskPrimaryColor: bt,
  readTaskAltColor: Ct,
  shareTaskDisabledColor: yt,
  shareTaskPrimaryColor: pt,
  shareTaskAltColor: Tt,
  dangerActiveColor: Bt,
  "copy-link-task-button": "Button-default-module__copy-link-task-button___fw3HE",
  "share-task-button": "Button-default-module__share-task-button___qce68",
  "read-task-button": "Button-default-module__read-task-button___PvjEh",
  "add-task-button": "Button-default-module__add-task-button___--Ljk",
  "disabled-task-button": "Button-default-module__disabled-task-button___zTcfJ",
  "disabled-button": "Button-default-module__disabled-button___8u-2X",
  "cancel-button": "Button-default-module__cancel-button___-2N4F",
  "warning-button": "Button-default-module__warning-button___VO2Gw",
  "danger-button": "Button-default-module__danger-button___kFW1w",
  "primary-muted-action-button": "Button-default-module__primary-muted-action-button___TofV-",
  "action-button": "Button-default-module__action-button___Wfdtf",
  "cta-button": "Button-default-module__cta-button___tBaXA",
  "base-button": "Button-default-module__base-button___4FUiN",
  outline: ht,
  linkButton: At,
  "cta-children": "Button-default-module__cta-children___4LhxI",
  "cta-children-stateful": "Button-default-module__cta-children-stateful___omU9G",
  stateful: Et,
  error: Nt,
  "full-width": "Button-default-module__full-width___kpaVZ",
  "disabled-cancel-button": "Button-default-module__disabled-cancel-button___M3Vns",
  secondary: Dt,
  icon: vt
}, gt = "#ccc", Lt = "#000", St = "#fff", wt = "#05ff7e", Pt = "#defab6", Rt = "#ccc", $t = "#000", Mt = "#00ffe1", Ut = "#00ffe1", It = "#ccc", Ot = "#c31e8a", zt = "#fff", Ft = "#ccc", Gt = "#9100b7", xt = "#fff", Ht = "Button-compere-module__outline___dNZ0C", Yt = "Button-compere-module__linkButton___-rUus", jt = "Button-compere-module__stateful___R6z1v", Vt = "Button-compere-module__error___A4Zij", qt = "Button-compere-module__secondary___yYCyL", Wt = "Button-compere-module__icon___dzIeM", I = {
  copyLinkTaskDisabledColor: gt,
  copyLinkTaskPrimaryColor: Lt,
  copyLinkTaskAltColor: St,
  actionActiveColor: wt,
  primaryMutedActionActiveColor: Pt,
  addTaskDisabledColor: Rt,
  addTaskPrimaryColor: $t,
  addTaskAltColor: Mt,
  addTaskActiveColor: Ut,
  readTaskDisabledColor: It,
  readTaskPrimaryColor: Ot,
  readTaskAltColor: zt,
  shareTaskDisabledColor: Ft,
  shareTaskPrimaryColor: Gt,
  shareTaskAltColor: xt,
  "copy-link-task-button": "Button-compere-module__copy-link-task-button___r9Kxu",
  "share-task-button": "Button-compere-module__share-task-button___c9yBU",
  "read-task-button": "Button-compere-module__read-task-button___6Ours",
  "add-task-button": "Button-compere-module__add-task-button___WVmwr",
  "disabled-task-button": "Button-compere-module__disabled-task-button___R0HBB",
  "disabled-button": "Button-compere-module__disabled-button___OoIUr",
  "warning-button": "Button-compere-module__warning-button___AqRXd",
  "cancel-button": "Button-compere-module__cancel-button___-EA19",
  "primary-muted-action-button": "Button-compere-module__primary-muted-action-button___tqrGp",
  "danger-button": "Button-compere-module__danger-button___HqlBY",
  "action-button": "Button-compere-module__action-button___D8CXt",
  "cta-button": "Button-compere-module__cta-button___nhB7S",
  "base-button": "Button-compere-module__base-button___1osU-",
  outline: Ht,
  linkButton: Yt,
  stateful: jt,
  error: Vt,
  "full-width": "Button-compere-module__full-width___k4t4T",
  "disabled-cancel-button": "Button-compere-module__disabled-cancel-button___cIdHy",
  secondary: qt,
  icon: Wt
}, n = Object.freeze({
  DEFAULT: "default",
  LOADING: "loading",
  SUCCESS: "success",
  ERROR: "error",
  RETRY: "retry"
}), Xt = ({
  secondary: t,
  iconColor: o
}) => t ? /* @__PURE__ */ e.createElement(et, { color: o, size: 20, thickness: 2 }) : /* @__PURE__ */ e.createElement(ot, { singleColor: !0, color: o, width: 3 }), Zt = ({
  secondary: t,
  iconColor: o
}) => t ? /* @__PURE__ */ e.createElement(S, { color: o, size: 20, name: "checkcircle" }) : /* @__PURE__ */ e.createElement(e.Fragment, null, "Success!"), Jt = ({
  secondary: t,
  iconColor: o
}) => t ? /* @__PURE__ */ e.createElement(S, { color: o, size: 20, name: "spinner_retry" }) : /* @__PURE__ */ e.createElement(e.Fragment, null, "Retry"), Kt = ({
  status: t,
  ...o
}) => t === n.LOADING || t === n.RETRY ? /* @__PURE__ */ e.createElement(Xt, { ...o }) : t === n.SUCCESS ? /* @__PURE__ */ e.createElement(Zt, { ...o }) : t === n.ERROR ? /* @__PURE__ */ e.createElement(Jt, { ...o }) : null, z = {
  default: N,
  compere: I
}, x = e.forwardRef(
  (t, o) => {
    const l = `noopener${t.isExternalLink ? " noreferrer" : ""}`, c = t.openInNewTab ? "_blank" : void 0;
    return /* @__PURE__ */ e.createElement(
      "a",
      {
        ref: o,
        className: t.class,
        href: t.href,
        rel: l,
        target: c
      },
      t.children
    );
  }
);
x.displayName = "ButtonWithHref";
const h = ({
  children: t,
  fullWidth: o,
  autoFocus: l,
  ariaLabel: c,
  disabled: u,
  ariaDescribedBy: k,
  handleClick: f,
  status: a = n.DEFAULT,
  type: m = "button",
  secondary: s,
  href: i,
  isExternalLink: w = !1,
  openInNewTab: P = !1,
  buttonClassName: E = "base-button",
  stateful: D = !1,
  error: R = !1,
  isTaskButton: v = !1,
  iconColor: _ = "white"
}) => {
  const B = v || E === "cancel-button", g = U(), { t: b } = T(), C = e.createRef();
  tt(
    () => {
      l && i && typeof i == "string" && C.current && C?.current?.focus();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [l, i]
  );
  const r = M.get(z, g, z.default);
  let d = "";
  a && [n.LOADING, n.RETRY].includes(a) ? d = b("loading") : s && a === n.ERROR ? d = b("retry") : s && a === n.SUCCESS ? d = b("success") : s && c !== void 0 && (d = c);
  const y = a !== n.DEFAULT ? /* @__PURE__ */ e.createElement(
    Kt,
    {
      status: a ?? n.DEFAULT,
      secondary: s ?? !1,
      iconColor: _
    }
  ) : (
    //  children must be wrapped in span to prevent
    //   JS errors when changing language
    /* @__PURE__ */ e.createElement("span", null, t)
  );
  if (u) {
    const O = v ? p(r["disabled-task-button"], {
      [r.secondary]: s
    }) : p(
      r["disabled-button"],
      r[`disabled-${E}`]
    );
    return (
      // eslint-disable-next-line react/button-has-type
      /* @__PURE__ */ e.createElement(
        "button",
        {
          autoFocus: l,
          className: p(O, {
            [r["full-width"]]: o,
            [r.outline]: B
          }),
          type: m,
          "aria-label": d,
          "aria-disabled": !0,
          "aria-describedby": k,
          onClick: (L) => {
            L.preventDefault();
          }
        },
        y
      )
    );
  }
  const $ = p({
    [r[E]]: !0,
    [r.secondary]: s,
    [r.stateful]: D || a === n.LOADING || a === n.SUCCESS || a === n.ERROR,
    [r.error]: R || a === n.ERROR || a === n.RETRY,
    [r["full-width"]]: o,
    [r.outline]: B
  });
  return i !== void 0 ? typeof i == "string" ? /* @__PURE__ */ e.createElement(
    x,
    {
      ref: C,
      class: p($, r.linkButton),
      href: i,
      openInNewTab: P,
      isExternalLink: w
    },
    t ?? ""
  ) : i((L = {}) => ({
    ...L,
    className: p($, L?.className),
    children: y
  })) : (
    // eslint-disable-next-line react/button-has-type
    /* @__PURE__ */ e.createElement(
      "button",
      {
        autoFocus: l,
        className: $,
        type: m,
        onClick: f,
        "aria-label": d,
        "aria-live": "polite"
      },
      y
    )
  );
};
class H extends e.Component {
  constructor() {
    super(...arguments), this.state = { hover: !1, focus: !1, active: !1 }, this.handleMouseEnter = () => {
      this.setState({ hover: !0 });
    }, this.handleMouseLeave = () => {
      this.setState({ hover: !1 });
    }, this.handleFocus = () => {
      this.setState({ focus: !0 });
    }, this.handleBlur = () => {
      this.setState({ focus: !1, active: !1 });
    }, this.handleMouseDown = () => {
      this.setState({ active: !0 });
    }, this.handleMouseUp = () => {
      this.setState({ active: !1 });
    };
  }
  render() {
    if (this.props.disabled)
      return this.props.children?.(this.state);
    const o = this.props.fullWidth ? "100%" : "auto";
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        role: "presentation",
        style: { display: "inline-block", width: `${o}` },
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onMouseDown: this.handleMouseDown,
        onMouseUp: this.handleMouseUp
      },
      this.props.children(this.state)
    );
  }
}
const Qt = ({
  href: t,
  isExternalLink: o = !1,
  openInNewTab: l = !1,
  children: c,
  fullWidth: u,
  autoFocus: k,
  disabled: f,
  ariaDescribedBy: a = void 0
}) => /* @__PURE__ */ e.createElement(H, { disabled: f, fullWidth: u }, ({ hover: m, focus: s }) => /* @__PURE__ */ e.createElement(
  h,
  {
    buttonClassName: "cta-button",
    disabled: f,
    fullWidth: u,
    autoFocus: k,
    href: t,
    isExternalLink: o,
    openInNewTab: l,
    ariaDescribedBy: a
  },
  /* @__PURE__ */ e.createElement(
    "div",
    {
      className: p({
        [N["cta-children"]]: !0,
        [N["cta-children-stateful"]]: s || m
      })
    },
    c
  ),
  /* @__PURE__ */ e.createElement(
    S,
    {
      color: "white",
      size: 20,
      style: {
        verticalAlign: "middle",
        marginTop: -5,
        marginBottom: -5,
        marginRight: -10,
        zIndex: -1,
        opacity: s || m ? 1 : 0,
        transition: "all 200ms"
      },
      name: "arrow_right_double"
    }
  )
)), F = {
  default: N,
  compere: I
}, Y = ({
  handleClick: t = () => {
  },
  status: o = n.DEFAULT,
  type: l = "button",
  children: c,
  fullWidth: u,
  autoFocus: k,
  ariaLabel: f,
  disabled: a,
  ariaDescribedBy: m = void 0
}) => {
  const s = U(), i = M.get(F, s, F.default);
  return /* @__PURE__ */ e.createElement(
    h,
    {
      buttonClassName: "action-button",
      iconColor: i.actionActiveColor,
      handleClick: t,
      status: o,
      type: l,
      fullWidth: u,
      autoFocus: k,
      ariaLabel: f,
      disabled: a,
      ariaDescribedBy: m
    },
    c
  );
};
Y.displayName = "ActionButton";
const G = {
  default: N,
  compere: I
}, A = ({
  activeColorName: t = "",
  altColorName: o,
  disabled: l = !1,
  disabledColorName: c,
  iconName: u,
  iconSize: k = 20,
  primaryColorName: f,
  secondary: a = !1,
  tooltipPlacement: m = "top",
  taskType: s,
  fullWidth: i,
  autoFocus: w,
  handleClick: P = () => {
  },
  status: E = n.DEFAULT,
  children: D,
  ariaDescribedBy: R
}) => {
  const v = U(), _ = M.get(G, v, G.default), B = D || s, g = /* @__PURE__ */ e.createElement(H, { disabled: l, fullWidth: i }, ({ hover: b, focus: C, active: r }) => {
    let d = _[c];
    l || (r && t !== "" ? d = _[t] : b || C ? d = _[o] : d = _[f]);
    let y = _.icon;
    return a && (b || C || r ? y = _["icon-secondary-stateful"] : y = _["icon-secondary"]), /* @__PURE__ */ e.createElement(
      h,
      {
        isTaskButton: !0,
        buttonClassName: `${s}-task-button`,
        stateful: C || b,
        ariaLabel: B,
        disabled: l,
        fullWidth: i,
        autoFocus: w,
        secondary: a,
        handleClick: P,
        status: E,
        ariaDescribedBy: R
      },
      /* @__PURE__ */ e.createElement(
        S,
        {
          color: d,
          size: k,
          className: y,
          name: u,
          fillColor: u !== "download"
        }
      ),
      a ? null : D
    );
  });
  return B && a ? /* @__PURE__ */ e.createElement(lt, { darkMode: !0 }, /* @__PURE__ */ e.createElement(at.Hover, { trigger: g, placement: m, short: !0 }, /* @__PURE__ */ e.createElement("div", { style: { whiteSpace: "nowrap" } }, /* @__PURE__ */ e.createElement(nt.Body2, null, B)))) : g;
}, j = ({
  children: t,
  secondary: o,
  ...l
}) => {
  const { t: c } = T();
  return /* @__PURE__ */ e.createElement(h, { buttonClassName: "cancel-button", ...l }, t ?? c("Cancel"));
};
j.displayName = "CancelButton";
const V = ({
  secondary: t,
  ...o
}) => /* @__PURE__ */ e.createElement(h, { buttonClassName: "danger-button", ...o });
V.displayName = "DangerButton";
const q = ({
  secondary: t,
  ...o
}) => /* @__PURE__ */ e.createElement(h, { buttonClassName: "primary-muted-action-button", ...o });
q.displayName = "MutedButton";
const W = (t) => /* @__PURE__ */ e.createElement(
  A,
  {
    taskType: "add",
    iconName: "plus",
    disabledColorName: "addTaskDisabledColor",
    primaryColorName: "addTaskPrimaryColor",
    altColorName: "addTaskAltColor",
    activeColorName: "addTaskActiveColor",
    iconSize: t.secondary ? 20 : 16,
    ...t
  }
);
W.displayName = "AddButton";
const X = (t) => {
  const { t: o } = T();
  return /* @__PURE__ */ e.createElement(
    A,
    {
      taskType: "add",
      iconName: "plus",
      disabledColorName: "addTaskDisabledColor",
      primaryColorName: "addTaskPrimaryColor",
      altColorName: "addTaskAltColor",
      activeColorName: "addTaskActiveColor",
      iconSize: t.secondary ? 20 : 16,
      ...t
    },
    o("Add to Presentation")
  );
};
X.displayName = "AddToPresentationButton";
const Z = (t) => {
  const { t: o } = T();
  return /* @__PURE__ */ e.createElement(
    A,
    {
      taskType: "add",
      iconName: "plus",
      disabledColorName: "addTaskDisabledColor",
      primaryColorName: "addTaskPrimaryColor",
      altColorName: "addTaskAltColor",
      activeColorName: "addTaskActiveColor",
      iconSize: t.secondary ? 20 : 16,
      ...t
    },
    o("Add Section to Presentation")
  );
};
Z.displayName = "AddSectionToPresentationButton";
const J = ({ children: t, ...o }) => {
  const { t: l } = T();
  return /* @__PURE__ */ e.createElement(
    A,
    {
      taskType: "read",
      iconName: "download_outline",
      disabledColorName: "readTaskDisabledColor",
      primaryColorName: "readTaskPrimaryColor",
      altColorName: "readTaskAltColor",
      ...o
    },
    t || l("Download")
  );
};
J.displayName = "DownloadButton";
const K = ({ ...t }) => {
  const { t: o } = T();
  return /* @__PURE__ */ e.createElement(
    A,
    {
      taskType: "share",
      iconName: "share",
      disabledColorName: "shareTaskDisabledColor",
      primaryColorName: "shareTaskPrimaryColor",
      altColorName: "shareTaskAltColor",
      ...t
    },
    o("Share")
  );
};
K.displayName = "ShareButton";
const Q = ({ ...t }) => {
  const { t: o } = T();
  return /* @__PURE__ */ e.createElement(
    A,
    {
      taskType: "copy-link",
      iconName: "copy_link",
      disabledColorName: "copyLinkTaskDisabledColor",
      primaryColorName: "copyLinkTaskPrimaryColor",
      altColorName: "copyLinkTaskAltColor",
      ...t,
      secondary: !0
    },
    o("Copy link")
  );
};
Q.displayName = "CopyLinkButton";
const ue = {
  CallToActionButton: Qt,
  ActionButton: Y,
  CancelButton: j,
  AddButton: W,
  AddToPresentationButton: X,
  AddSectionToPresentationButton: Z,
  DownloadButton: J,
  ShareButton: K,
  Status: n,
  DangerButton: V,
  MutedButton: q,
  CopyLinkButton: Q
};
export {
  ue as B
};
